module.exports = __webpack_public_path__ + "img/Tarator-Bg.b4271c09.jpg";